module.exports = __webpack_public_path__ + "img/screen-2.e4dcc76b.jpg";